import { ObjectDirective } from "vue";

const directive: ObjectDirective = {
    inserted(el, node) {
        let tooltip = el.querySelector('.tooltip');

        if (tooltip) {
            el.addEventListener('mouseover', mouseover, false);
            el.addEventListener('mouseout', mouseout, false);
            el.addEventListener('mousemove', mousemove, false);
        }

        function mouseover(e) {
            tooltip.style.display = 'block';
        }

        function mouseout(e) {
            tooltip.style.display = 'none';
        }

        function mousemove(e) {
            tooltip.style.left = e.pageX + 'px';
            tooltip.style.top = e.pageY + 'px';
        }
    }
};

export default directive;